const bindings = [
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'CenterZoom' },
    label: 'Zoom',
    keys: ['z'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Pan' },
    label: 'Pan',
    keys: ['p'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'StackScroll' },
    label: 'Stack Scroll',
    keys: ['s'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'WindowLevel' },
    label: 'Window Level',
    keys: ['w'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Length' },
    label: 'Length',
    keys: ['d'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Probe' },
    label: 'HU Unit',
    keys: ['u'],
    isEditable: true,
  },
  {
    commandName: 'scaleUpViewport',
    label: 'Zoom In',
    keys: ['+'],
    isEditable: true,
  },
  {
    commandName: 'scaleDownViewport',
    label: 'Zoom Out',
    keys: ['-'],
    isEditable: true,
  },
  {
    commandName: 'fitViewportToWindow',
    label: 'Zoom to Fit',
    keys: ['='],
    isEditable: true,
  },
  {
    commandName: 'rotateViewportCW',
    label: 'Rotate Right',
    keys: ['r'],
    isEditable: true,
  },
  {
    commandName: 'rotateViewportCCW',
    label: 'Rotate Left',
    keys: ['l'],
    isEditable: true,
  },
  {
    commandName: 'flipViewportHorizontal',
    label: 'Flip Horizontally',
    keys: ['h'],
    isEditable: true,
  },
  {
    commandName: 'flipViewportVertical',
    label: 'Flip Vertically',
    keys: ['v'],
    isEditable: true,
  },
  {
    commandName: 'toggleCine',
    label: 'Cine',
    keys: ['c'],
  },
  {
    commandName: 'invertViewport',
    label: 'Invert',
    keys: ['i'],
    isEditable: true,
  },
  {
    commandName: 'incrementActiveViewport',
    label: 'Next Image Viewport',
    keys: ['right'],
    isEditable: true,
  },
  {
    commandName: 'decrementActiveViewport',
    label: 'Previous Image Viewport',
    keys: ['left'],
    isEditable: true,
  },
  {
    commandName: 'updateViewportDisplaySet',
    commandOptions: {
      direction: -1,
    },
    label: 'Previous Series',
    keys: ['pageup'],
    isEditable: true,
  },
  {
    commandName: 'updateViewportDisplaySet',
    commandOptions: {
      direction: 1,
    },
    label: 'Next Series',
    keys: ['pagedown'],
    isEditable: true,
  },
  {
    commandName: 'nextStage',
    context: 'DEFAULT',
    label: 'Next Stage',
    keys: ['.'],
    isEditable: true,
  },
  {
    commandName: 'previousStage',
    context: 'DEFAULT',
    label: 'Previous Stage',
    keys: [','],
    isEditable: true,
  },
  {
    commandName: 'nextImage',
    label: 'Next Image',
    keys: ['down'],
    isEditable: true,
  },
  {
    commandName: 'previousImage',
    label: 'Previous Image',
    keys: ['up'],
    isEditable: true,
  },
  {
    commandName: 'firstImage',
    label: 'First Image',
    keys: ['home'],
    isEditable: true,
  },
  {
    commandName: 'lastImage',
    label: 'Last Image',
    keys: ['end'],
    isEditable: true,
  },
  {
    commandName: 'resetViewport',
    label: 'Reset',
    keys: ['space'],
    isEditable: true,
  },
  {
    commandName: 'cancelMeasurement',
    label: 'Cancel Measurement',
    keys: ['esc'],
  },
  // Positional by design: key N applies the Nth preset of whatever modality is in
  // the active viewport. The label deliberately names no window, because the
  // target differs per modality -- which window each slot holds is decided by the
  // preset order in defaultWindowLevelPresets.ts, where CT is arranged so slots
  // 1-4 are Default / Lung / Bone / Soft tissue.
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetIndex: 0 },
    label: 'W/L Preset 1',
    keys: ['1'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetIndex: 1 },
    label: 'W/L Preset 2',
    keys: ['2'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetIndex: 2 },
    label: 'W/L Preset 3',
    keys: ['3'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetIndex: 3 },
    label: 'W/L Preset 4',
    keys: ['4'],
  },
  {
    commandName: 'deleteActiveAnnotation',
    label: 'Delete Annotation',
    keys: ['backspace', 'del'],
  },
  // {
  //   commandName: 'acceptPreview',
  //   label: 'Accept Preview',
  //   keys: ['enter'],
  // },
  // {
  //   commandName: 'rejectPreview',
  //   label: 'Reject Preview',
  //   keys: ['esc'],
  // },
  {
    commandName: 'undo',
    label: 'Undo',
    keys: ['ctrl+z'],
    isEditable: true,
  },
  {
    commandName: 'redo',
    label: 'Redo',
    keys: ['ctrl+y'],
    isEditable: true,
  },
  // {
  //   commandName: 'interpolateScrollForMarkerLabelmap',
  //   label: 'Interpolate Scroll',
  //   keys: ['n'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'increaseBrushSize',
  //   label: 'Increase Brush Size',
  //   keys: [']'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'decreaseBrushSize',
  //   label: 'Decrease Brush Size',
  //   keys: ['['],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'setToolActive',
  //   commandOptions: { toolName: 'CircularEraser' },
  //   label: 'Eraser',
  //   keys: ['e'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'setToolActive',
  //   commandOptions: { toolName: 'CircularBrush' },
  //   label: 'Brush',
  //   keys: ['b'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'addNewSegment',
  //   label: 'Add New Segment',
  //   keys: ['a'],
  //   isEditable: true,
  // },
  {
    commandName: 'openDICOMTagViewer',
    label: 'Open DICOM Tag Browser',
    keys: ['t'],
    isEditable: true,
  },
];

export default bindings;
